module.exports = __webpack_public_path__ + "img/entrees.24b5233a.svg";